/*!
 =========================================================
 * Material Dashboard React - v1.3.0 (Musaned premium tokens)
 =========================================================
 */

const drawerWidth = 248;

const transition = {
  transition: 'all 0.28s cubic-bezier(0.4, 0, 0.2, 1)',
};

const container = {
  paddingRight: '20px',
  paddingLeft: '20px',
  marginRight: 'auto',
  marginLeft: 'auto',
};

const cardCategory = {};

const boxShadow = {
  boxShadow: '0 1px 2px rgba(31, 42, 50, 0.04), 0 8px 24px rgba(31, 42, 50, 0.06)',
};

const card = {
  display: 'inline-block',
  position: 'relative',
  width: '100%',
  margin: '25px 0',
  boxShadow: '0 1px 2px rgba(31, 42, 50, 0.04), 0 8px 24px rgba(31, 42, 50, 0.06)',
  borderRadius: '12px',
  border: '1px solid #E2E8EB',
  color: '#1F2A32',
  background: '#fff',
};

const fontSize = {
  xs: 10,
  s: 12,
  m: 14,
  l: 16,
  xl: 18,
  xxl: 20,
};

const defaultFont = {
  fontFamily: 'FrutigerRegular, Tahoma, Arial, sans-serif',
  fontWeight: '400',
  lineHeight: '1.5em',
};

// Premium institutional palette (Musaned / Tamkeen ops)
const primaryColor = '#00A8BC';
const primaryDarkColor = '#008A9A';
const warningColor = '#E67E22';
const dangerColor = '#D64545';
const successColor = '#1B9E6E';
const infoColor = '#2F80B5';
const roseColor = '#C45B7A';
const grayColor = '#6B7780';
const pageBgColor = '#F4F7F8';
const panelBgColor = '#FFFFFF';
const sidebarBgColor = '#FAFCFC';
const textPrimaryColor = '#1F2A32';
const textMutedColor = '#6B7780';
const borderSubtleColor = '#E2E8EB';

const primaryBoxShadow = {
  boxShadow: '0 8px 20px -8px rgba(0, 168, 188, 0.35), 0 2px 8px rgba(31, 42, 50, 0.06)',
};
const infoBoxShadow = {
  boxShadow: '0 8px 20px -8px rgba(47, 128, 181, 0.3), 0 2px 8px rgba(31, 42, 50, 0.06)',
};
const successBoxShadow = {
  boxShadow: '0 8px 20px -8px rgba(27, 158, 110, 0.3), 0 2px 8px rgba(31, 42, 50, 0.06)',
};
const warningBoxShadow = {
  boxShadow: '0 8px 20px -8px rgba(230, 126, 34, 0.3), 0 2px 8px rgba(31, 42, 50, 0.06)',
};
const dangerBoxShadow = {
  boxShadow: '0 8px 20px -8px rgba(214, 69, 69, 0.3), 0 2px 8px rgba(31, 42, 50, 0.06)',
};
const roseBoxShadow = {
  boxShadow: '0 8px 20px -8px rgba(196, 91, 122, 0.3), 0 2px 8px rgba(31, 42, 50, 0.06)',
};

const warningCardHeader = {
  background: 'linear-gradient(135deg, #F0A35A, #E67E22)',
  ...warningBoxShadow,
};
const successCardHeader = {
  background: 'linear-gradient(135deg, #3CB88A, #1B9E6E)',
  ...successBoxShadow,
};
const dangerCardHeader = {
  background: 'linear-gradient(135deg, #E56B6B, #D64545)',
  ...dangerBoxShadow,
};
const infoCardHeader = {
  background: 'linear-gradient(135deg, #4F9BC7, #2F80B5)',
  ...infoBoxShadow,
};
const primaryCardHeader = {
  background: 'linear-gradient(135deg, #33B9C9, #00A8BC)',
  ...primaryBoxShadow,
};
const roseCardHeader = {
  background: 'linear-gradient(135deg, #D47A95, #C45B7A)',
  ...roseBoxShadow,
};

const cardActions = {
  margin: '0 20px 10px',
  paddingTop: '10px',
  borderTop: `1px solid ${borderSubtleColor}`,
  height: 'auto',
  ...defaultFont,
};

const cardHeader = {
  margin: '-20px 15px 0',
  borderRadius: '10px',
  padding: '15px',
};

const defaultBoxShadow = {
  border: '0',
  borderRadius: '10px',
  boxShadow: '0 1px 2px rgba(31, 42, 50, 0.04), 0 8px 24px rgba(31, 42, 50, 0.06)',
  padding: '10px 0',
  transition: 'all 150ms ease 0s',
};

const title = {
  color: textPrimaryColor,
  textDecoration: 'none',
  fontWeight: '500',
  marginTop: '30px',
  marginBottom: '25px',
  minHeight: '32px',
  fontFamily: 'FrutigerRegular, Tahoma, Arial, sans-serif',

  '& small': {
    color: textMutedColor,
    fontSize: '65%',
    fontWeight: '400',
    lineHeight: '1',
  },
};

const cardTitle = {
  ...title,
  marginTop: '0',
  marginBottom: '3px',
  minHeight: 'auto',
  '& a': {
    ...title,
    marginTop: '.625rem',
    marginBottom: '0.75rem',
    minHeight: 'auto',
  },
};

const cardSubtitle = {
  marginTop: '-.375rem',
};

const cardLink = {
  '& + $cardLink': {
    marginLeft: '1.25rem',
  },
};

export {
  drawerWidth,
  transition,
  container,
  boxShadow,
  card,
  defaultFont,
  primaryColor,
  primaryDarkColor,
  warningColor,
  dangerColor,
  successColor,
  infoColor,
  roseColor,
  grayColor,
  pageBgColor,
  panelBgColor,
  sidebarBgColor,
  textPrimaryColor,
  textMutedColor,
  borderSubtleColor,
  primaryBoxShadow,
  infoBoxShadow,
  successBoxShadow,
  warningBoxShadow,
  dangerBoxShadow,
  roseBoxShadow,
  warningCardHeader,
  successCardHeader,
  dangerCardHeader,
  infoCardHeader,
  primaryCardHeader,
  roseCardHeader,
  cardActions,
  cardHeader,
  defaultBoxShadow,
  title,
  cardTitle,
  cardSubtitle,
  cardLink,
  cardCategory,
  fontSize,
};
